import { combineReducers } from "redux";

import { intlReducer } from "react-intl-redux";
import GeneralSettings from "./general-settings";
import Api from "./api";
import ChatList from "./chat-list";
import Chats from "./chats";
import Users from "./users";
import ProcessInstances from "./processInstances";

export default combineReducers({
  intl: intlReducer,
  GeneralSettings,
  Api,
  ChatList,
  Chats,
  Users,
  ProcessInstances,
});
